interface Props { score: number | null | undefined }

export function ScoreBadge({ score }: Props) {
  if (score == null) return null;
  const colour = score >= 8 ? '#c0392b' : score >= 6 ? '#e67e22' : '#7f8c8d';
  return (
    <span style={{
      display: 'inline-block',
      background: colour,
      color: '#fff',
      borderRadius: 3,
      padding: '1px 7px',
      fontSize: 11,
      fontWeight: 700,
    }}>
      {score}/10
    </span>
  );
}
